import React from 'react';
import ButtonGroup from '../../common/buttons/ButtonGroup';

const BottomControls = ({ buttons }) => {
  return (
    <ButtonGroup buttons={buttons} />
  );
};

export default BottomControls;